import React from 'react';
import classNames from 'classnames';
import IconPriceTag from '@spothero/icons/price-tag';
import IconShield from '@spothero/icons/shield';
import IconEditPencilSquare from '@spothero/icons/edit-pencil-square';
import Card from 'common/card/Card';

const CONTENT = [
    {
        title: 'Great Deals',
        icon: IconPriceTag,
        iconColor: 'green',
        description:
            'Save money when you book online with fast secure checkout.',
    },
    {
        title: 'Guaranteed Reservation',
        icon: IconShield,
        iconColor: 'yellow',
        description:
            'Reserve a spot at one of our 400+ parking partners nationwide.',
    },
    {
        title: 'Flexible Booking',
        icon: IconEditPencilSquare,
        iconColor: 'blue',
        description: 'Plans change? Edit or extend your reservation online.',
    },
];

const WhyBook = () => (
    <Card className="WhyBook">
        <h2 className="WhyBook-title">Why Book With SpotHero</h2>
        <ul className="WhyBook-items">
            {CONTENT.map((item, index) => {
                const iconClassNames = classNames(
                    'WhyBook-icon',
                    `${item.iconColor}`
                );

                return (
                    <li key={index} className="WhyBook-item">
                        <div className={iconClassNames}>
                            <item.icon />
                        </div>
                        <h3 className="item-label">{item.title}</h3>
                        <p className="item-description">{item.description}</p>
                    </li>
                );
            })}
        </ul>
    </Card>
);

export default WhyBook;
